import Layout from './Layout';
import useResponsive from '../../shared/utils/Responsive';
import StudentSmallScreen from './StudentSmallScreen';
import StudentLoginForm from './StudentLoginForm';
const StudentUserLogin = () => {
    const isSmallScreen = useResponsive("md")
    return (
        <>
            {
                !isSmallScreen && (
                    <Layout text={"Student login to continue your learning journey."}>
                        <StudentLoginForm />
                    </Layout>
                )
            }
            {
                isSmallScreen && <StudentSmallScreen tabPage={0} />
            }

        </>

    )
}
export default StudentUserLogin












